import { TSvgComponentProps } from './types';

/**
 * -----------------------------------------------------------------------------
 * This renders a rectangular Icon/Flag that shows the Arabic language symbol in
 * focus. This is to be used by CTA to indicate a trigger to switch the locale
 * to the Arabic language
 *
 * @param {{size: number}}
 */
export function FlagIsrael({ size = 32, ...rest }: TSvgComponentProps) {
  return (
    <svg
      fill="none"
      height={size}
      id="FlagHebrew"
      viewBox="0 0 36 24"
      width={size * 1.5}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_6227_19697)">
        <path d="M36 0H0V24H36V0Z" fill="white" />
        <path
          d="M17.9999 17.9788C21.289 17.9788 23.9554 15.302 23.9554 12C23.9554 8.69799 21.289 6.02118 17.9999 6.02118C14.7108 6.02118 12.0444 8.69799 12.0444 12C12.0444 15.302 14.7108 17.9788 17.9999 17.9788Z"
          stroke="#9333EA"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="0.705882"
        />
        <path
          d="M18 5.95056V17.9082M18 5.95056C16.1719 5.95056 14.7024 8.6188 14.7024 11.9294C14.7024 15.24 16.1719 17.9082 18 17.9082M18 5.95056C19.8282 5.95056 21.2977 8.6188 21.2977 11.9294C21.2977 15.24 19.8282 17.9082 18 17.9082"
          stroke="#9333EA"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="0.705882"
        />
        <path
          d="M23.1046 14.9929H12.8953"
          stroke="#9333EA"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="0.705882"
        />
        <path
          d="M23.9554 12H12.0444"
          stroke="#9333EA"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="0.705882"
        />
        <path
          d="M23.1046 9.00708H12.8953"
          stroke="#9333EA"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="0.705882"
        />
        <g clipPath="url(#clip1_6227_19697)">
          <path d="M0 -1H36V25H0V-1Z" fill="white" />
          <path d="M0 1.4375H36V5.5H0V1.4375Z" fill="#0038B8" />
          <path d="M0 18.5H36V22.5625H0V18.5Z" fill="#0038B8" />
          <path
            d="M13.8704 14.3677H22.1297L18 7.26459L13.8704 14.3677ZM18 16.7354L22.1297 9.63229H13.8704L18 16.7354Z"
            stroke="#0038B8"
            strokeWidth="0.773438"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_6227_19697">
          <rect fill="white" height="24" rx="6" width="36" />
        </clipPath>
        <clipPath id="clip1_6227_19697">
          <rect
            fill="white"
            height="26"
            transform="translate(0 -1)"
            width="36"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
